"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractDomain = void 0;
exports.extractDomain = (email) => {
    const parts = email.split("@");
    return parts.length > 1 ? parts[1] : "";
};
